<script>
   /*************************************************************/
   /* Root component for the application                        */
   /*************************************************************/

   import { date2str } from '../../shared/utils';

   import TrainAppContainer from './tab_train/AppContainer.svelte';
   import PredictAppContainer from './tab_new/AppContainer.svelte';
   import App from '../../shared/components/MainApp.svelte';
   import WASM from '../../shared/wasm/dist/pca_wasm.js';

   /* callback for reseting the app via session */
   function resetSession(s) {
      s.train.dataset = null;
      s.new.model = null;
      s.tab = 0;
   }

   /* callback to check validity of JSON with session */
   function checkSession(s) {
      const keys1 = Object.keys(s);
      if (!['date', 'tab', 'train', 'new'].every(v => keys1.includes(v))) return false;

      const keys2 = Object.keys(s.train);
      const keys3 = Object.keys(s.new);
      if (!['model', 'dataset', 'resobj', 'outliers'].every(v => keys2.includes(v) && keys3.includes(v))) return false;
      return true;
   }

   /* callback to initialize new session */
   function initSession() {
      return {
         date: date2str(new Date()),
         tab: 0,
         train: {
            model : 0,
            dataset: 0,
            resobj: 0,
            outliers: [],
         },
         new: {
            model : 0,
            dataset: 0,
            resobj: 0,
            outliers: []
         }
      }
   }

   // app containers
   const tabs = [
      {name: 'Train', label: 'train', component: TrainAppContainer},
      {name: 'Project', label: 'new', component: PredictAppContainer},
   ]
</script>

<App
   appID="pca"
   appTitle="PCA"
   appShortTitle="PCA"
   appSlogan="Principal component analysis"
   {WASM}
   {tabs}
   {initSession}
   {checkSession}
   {resetSession}
>

   {#snippet footer()}
      <p>Current release: <span>2.0.10</span>
      Feedback: <a class="paper-link" href="mailto:help@mda.tools?subject=PCA app">help@mda.tools</a>
      Tutorial: <a class="paper-link" href="Wines.zip" download>dataset</a>
      | <a href="https://www.youtube.com/playlist?list=PLep7KM9cEyFnCpcLEwI63Zj1YJZrVL0WH">video lessons</a>
      </p>
   {/snippet}

   {#snippet info()}
   <h2>Principal Component Analysis</h2>
   <p>Authors: <em>Sergey Kucheryavskiy, Oxana Rodionova, Alexey Pomerantsev</em></p>
   <p>
      Interactive web-application for creating and using PCA models for data exploration
      directly in your browser. The app does not send any information to the server,
      all calculations are done locally on your device.
   </p>
   <p>Check out YouTube <a href="https://www.youtube.com/playlist?list=PLep7KM9cEyFnCpcLEwI63Zj1YJZrVL0WH">video-lessons</a>
   <h3>v. 2.0.8-2.0.10</h3>
   <p class="release-info">released 21/05/2025</p>
   <ul>
      <li>Fixed bug in contributions plot and several minor issues.</li>
   </ul>
   <h3>v. 2.0.7</h3>
   <p class="release-info">released 16/04/2025</p>
   <ul>
      <li>App now remembers the plot settings when you switch between plots.</li>
      <li>Introducing sessons — app states, including model, results, datasets, and outliers
         (in all tabs). When you close tab or app window or click on reboot button, the current
         session is saved to browser's local storage and then is restored automatically. You can
         also download session as a file and load it from file.
      </li>
      <li>Added undo option for outliers (if more than one is removed).</li>
      <li>More robust CSV converter which filters out empty rows created by some versions of MS Excel.</li>
      <li>Many small improvements to plots and control elements.</li>
   </ul>
   {/snippet}
</App>

